<div class="select-container"
     [class.disabled]="disabled()"
     tabindex="0">
  @if (!open() || !searchable()) {
    <div class="select-label" [class.disabled]="disabled()" (click)="toggleDropdown()">
      <span class="select-display-text" [class.with-mod-name]="selectedOption()?.modName()">
        @if (selectedOption(); as option) {
          @if (option.gte()) { ≥ }
          @if (option.lte()) { ≤ }
          @if (option.eq()) { = }

          @switch (resolvedDisplayMode()) {
            @case ('textOnly') {
              <span class="option-text-truncate" [textContent]="option.text()" [style.color]="option.color() || undefined"></span>
              @if (option.modName()) {
                <span class="option-mod-name">{{ option.modName() }}</span>
              }
            }
            @case ('iconOnly') {
              @if (option.imgUrl()) {
                <span class="image-container"><img class="inline-image" [src]="option.imgUrl()" [alt]="option.alt()"></span>
              } @else if (option.imgSet()) {
                <span class="image-container">
                  @for (img of option.imgSet(); track img) {
                    <img class="inline-image" [src]="img" [alt]="option.alt()">
                  }
                </span>
              } @else if (option.rarity()) {
                <div class="rarity-circle" [class]="'rarity-' + option.rarity()!.toLowerCase()"></div>
              } @else if (option.gearTier()) {
                <app-gear-tier-icon [tier]="option.gearTier()!"></app-gear-tier-icon>
              } @else if (option.minimapIcon()) {
                <app-minimap-icon [cosmeticOptions]="getMinimapIconOptions(option.minimapIcon()!)"></app-minimap-icon>
              }
            }
            @case ('prefixAndText') {
              @if (option.imgUrl()) {
                <span class="image-container" style="margin-right: 4px;">
                  <img class="inline-image" [src]="option.imgUrl()" [alt]="option.alt()">
                </span>
              } @else if (option.imgSet()) {
                <span class="image-container" style="margin-right: 4px;">
                  @for (img of option.imgSet(); track img) {
                    <img class="inline-image" [src]="img" [alt]="option.alt()">
                  }
                </span>
              } @else if (option.rarity()) {
                <div class="rarity-circle" [class]="'rarity-' + option.rarity()!.toLowerCase()" style="margin-right: 4px;"></div>
              } @else if (option.gearTier()) {
                <app-gear-tier-icon [tier]="option.gearTier()!" style="margin-right: 4px;"></app-gear-tier-icon>
              } @else if (option.minimapIcon()) {
                <app-minimap-icon [cosmeticOptions]="getMinimapIconOptions(option.minimapIcon()!)" style="margin-right: 4px;"></app-minimap-icon>
              }
              <span [textContent]="option.text()" [style.color]="option.color() || undefined"></span>
            }
            @case ('textAndSuffix') {
              <span [textContent]="option.text()" [style.color]="option.color() || undefined"></span>
              @if (option.imgUrl()) {
                <span class="image-container" style="margin-left: 4px;">
                  <img class="inline-image" [src]="option.imgUrl()" [alt]="option.alt()">
                </span>
              } @else if (option.imgSet()) {
                <span class="image-container" style="margin-left: 4px;">
                  @for (img of option.imgSet(); track img) {
                    <img class="inline-image" [src]="img" [alt]="option.alt()">
                  }
                </span>
              } @else if (option.rarity()) {
                <div class="rarity-circle" [class]="'rarity-' + option.rarity()!.toLowerCase()" style="margin-left: 4px;"></div>
              } @else if (option.gearTier()) {
                <app-gear-tier-icon [tier]="option.gearTier()!" style="margin-left: 4px;"></app-gear-tier-icon>
              } @else if (option.minimapIcon()) {
                <app-minimap-icon [cosmeticOptions]="getMinimapIconOptions(option.minimapIcon()!)" style="margin-left: 4px;"></app-minimap-icon>
              }
            }
            @default {
              <span [textContent]="option.text()" [style.color]="option.color() || undefined"></span>
            }
          }
        }
      </span>
      <span class="select-arrow">▼</span>
    </div>
  } @else {
    <div class="select-input-container">
      <input
        #searchInput
        type="text"
        class="select-search-input"
        placeholder="Search options"
        [(ngModel)]="searchText"
        (click)="$event.stopPropagation()">
      <span class="select-arrow">▼</span>
    </div>
  }

  @if (open()) {
    <div class="select-options poe-scrollbar" [class.align-left]="alignLeft()"
         #optionsContainer
         [class.full-width]="fullWidth()">
      @for (option of filteredOptions(); track option.value(); let i = $index) {
        <div class="select-option"
             [attr.data-value]="option.value() === undefined ? 'undefined' : option.value()"
             [class.selected]="selectedValue() === option.value()"
             [class.highlighted]="highlightedIndex() === i"
             (click)="selectOption(option)"
             (mouseenter)="hovered(option.text())"
             (mouseleave)="unhovered()">
          <span class="option-content">
            @if (option.gte()) { ≥ }
            @if (option.lte()) { ≤ }
            @if (option.eq()) { = }
            @if (option.imgUrl()) {
              <span class="image-container" style="margin-right: 4px;">
                <img class="inline-image" [src]="option.imgUrl()" [alt]="option.alt()">
              </span>
            }
            @if (option.imgSet()) {
              <span class="image-container">
                @for (img of option.imgSet(); track img) {
                  <img class="inline-image" [src]="img" [alt]="option.alt()">
                }
              </span>
            }
            @if (option.rarity()) {
              <div class="rarity-circle" [class]="'rarity-' + option.rarity()!.toLowerCase()" style="margin-right: 4px;"></div>
            }
            @if (option.minimapIcon()) {
              <app-minimap-icon [cosmeticOptions]="getMinimapIconOptions(option.minimapIcon()!)" style="margin-right: 4px;"></app-minimap-icon>
            }
            @if (option.dropdownText() || option.text()) {
              <span class="option-text-truncate" [textContent]="option.dropdownText() ?? option.text()" [style.color]="option.color() || undefined"></span>
            }
          </span>
          @if (option.modName()) {
            <span class="option-mod-name">{{ option.modName() }}</span>
          } @else if (option.gearTier()) {
            <span class="option-gear-tier">
              <app-gear-tier-icon [tier]="option.gearTier()!"></app-gear-tier-icon>
            </span>
          }
        </div>
      }
      @if (!hideHoverInfo() && extraInfo && extraInfo.length > 0) {
        <div class="select-info-container">
          @if (settings.showValueInDropdowns() && value) {
            <div class="select-value" app-value [value]="value" [rtl]="true" [round]="2"></div>
          }
          <div class="select-info">
            @for (info of extraInfo; track $index) {
              <div [innerHTML]="info"></div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>

<ng-content></ng-content>
